"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableContainerOverrides = void 0;
var createMuiTableContainerOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            '[class*="MuiPaper-root"] > &': {
                padding: spacing(0, 4, 4),
            },
        },
    });
};
exports.createMuiTableContainerOverrides = createMuiTableContainerOverrides;
//# sourceMappingURL=MuiTableContainer.js.map